import React, { useState, useEffect } from "react";
import { KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import Moment from "moment";
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import Grid from "@material-ui/core/Grid";
import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import krLoacale from "date-fns/locale/ko";
import calStore from "../../stores/calculateStore";

function DatePick(props) {
  // const lastHisDate = props.lastHisDate;

  const [selectedDateSt, setSelectedDateSt] = React.useState(Moment().date('01').hours('00').minutes('00').seconds('01'));
  // const [selectedDateSt, setSelectedDateSt] = React.useState(lastHisDate == null ? Moment().date('01') : Moment(lastHisDate));
  const [selectedDateEd, setSelectedDateEd] = React.useState(Moment().hours('23').minutes('59').seconds('59'));

  const handleDateChangeSt = (date) => {
    setSelectedDateSt(prevDateSt => prevDateSt = Moment(date))
  };

  const handleDateChangeEd = (date) => {
    setSelectedDateEd(prevDateEd => prevDateEd = Moment(date))
  };
  
  const handleApply = () => {
    if( selectedDateSt.isSameOrBefore(selectedDateEd)) //시작날짜는 종료날짜와 같거나 작아야됨.
    {
      calStore.setDate(Moment(selectedDateSt).hours('00').minutes('00').seconds('01'),Moment(selectedDateEd).hours('23').minutes('59').seconds('59'));
    }
    else
      alert('시작날짜가 종료날짜보다 큽니다.');
  };
  return (
  <MuiPickersUtilsProvider locale={krLoacale} utils={DateFnsUtils}>
    <Grid container direction="row" spacing={1}>
      <Grid item xs={12}>
        <KeyboardDatePicker
            margin="normal"
            id="date-picker-dialog"
            label="시작 날짜"
            format="yyyy.MM.dd."
            value={selectedDateSt}
            onChange={handleDateChangeSt}
            KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              />
          <KeyboardDatePicker
            margin="normal"
            style={{ marginLeft: "10px" }} 
            id="date-picker-dialog"
            label="종료 날짜"
            format="yyyy.MM.dd"
            value={selectedDateEd}
            onChange={handleDateChangeEd}
            KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              />     
      <Button 
        variant="contained" 
        size="small"
        color="primary"
        style={{ marginTop: "35px", marginLeft: "10px" }} 
        onClick={handleApply}
      >
        날짜검색
      </Button>           
      </Grid>
    </Grid>
  </MuiPickersUtilsProvider>
  );
}

export default DatePick;